import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licensing-agreement',
  templateUrl: './licensing-agreement.component.html',
  styleUrls: ['./licensing-agreement.component.css']
})
export class LicensingAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
